import axios from "axios/index";
import { API_BASE } from "../api";

export default store => {
  return {
    $store: store,
    login(user, pass) {
      this.$store.commit("loading", true);
      return axios({
        method: "post",
        url: API_BASE + "/authtoken/",
        data: {
          username: user,
          password: pass
        }
      })
        .then(response => {
          this.$store.dispatch("login", response.data);
          this.$store.commit("loading", false);
          this.$store.commit("setUserDetails", user);
          return response;
        })
        .catch(error => {
          throw error;
        });
    },
    logout() {
      this.$store.dispatch("logout");
    }
  };
};
